import base from "@/lib/backendCall/base";

async function getRedeemablePageData(storeAccount) {
    return await base.httpReq(
        true,
        "get",
        `/redeemable/redeemablePageData`,
        null,
        {storeAccount}
    )
}



export default {
    getRedeemablePageData
}